// removed by extract-text-webpack-plugin
module.exports = {"FormRow":"_2ufXZ","Count":"_1TeuF","FormSmall":"_2OW9Z","FormLarge":"_1Nck-","Title":"_1uM9M","TitleActive":"_33Bqf","FormRowInner":"_jrRCz","FormUnique":"_2F50D","CustomInput":"_3KtZE","Label":"_3a3cW","Bar":"_xzsIL"};


//////////////////
// WEBPACK FOOTER
// ./src/components/Pax/Pax.scss
// module id = 470
// module chunks = 0